import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=5244a528&scoped=true&"
import script from "./Ad.vue?vue&type=script&lang=js&"
export * from "./Ad.vue?vue&type=script&lang=js&"
import style0 from "./Ad.vue?vue&type=style&index=0&id=5244a528&lang=stylus&scoped=true&"
import style1 from "./Ad.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244a528",
  null
  
)

export default component.exports